<template>
  <div class="filter-set location">
    <button
      class="filter-name"
      @click.stop="$emit('toggle')"
      :class="getBoxClass()"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      :aria-controls="config.testing.FILTER_LOCATION_INPUT + '-panel'"
      id="location-toggle"
    >
      <span class="filter-name__label">Sijainti</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible">
      <div
        :id="config.testing.FILTER_LOCATION_INPUT + '-panel'"
        class="location-expander-panel"
        role="region"
        aria-labelledby="location-toggle"
      >
        <autocomplete
          :id="config.testing.FILTER_LOCATION_INPUT"
          :resultsId="config.testing.FILTER_LOCATION_RESULTS"
          className="location-input"
          :emptyInput="true"
        ></autocomplete>
      </div>
    </expander>
    <active-filters v-if="type === 'mobile'" showOnly="location"></active-filters>
  </div>
</template>

<script>
import config from '@/config';
import Expander from '../expander/expander.vue';
import FormInput from '../form-input/form-input.vue';
import { mapGetters } from 'vuex';
import Autocomplete from '@/app/components/autocomplete/autocomplete.vue';
import ActiveFilters from '../active-filters/active-filters.vue';
import searchUtils from '@/app/utils/search-utils';

export default {
  name: 'location',
  data: () => ({
    config,
    locationInput: '',
  }),
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined, // By default, the expander is visible but without any complex close/open css logic
    },
    locationFilters: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
    },
  },
  methods: {
    getBoxClass() {
      return searchUtils.hasLocationFilters(this.locationFilters) ? 'in-use' : '';
    },
    closeExpanderIfNotInMobile() {
      if (this.type !== 'mobile') {
        this.$emit('toggle');
      }
    },
  },
  computed: mapGetters({
    getFilterValue: 'getFilterValue',
  }),
  mounted() {
    this.$bus.$on('autocompleteDistrictSelected', (district) => {
      const resultingArray = this.getFilterValue('districtId').concat([district.districtId]);
      if (resultingArray.length > 0) {
        const allowMultiple = !!this.$route.query?.districtId;
        searchUtils.addFilterToUrl(this.$router, this.$route, { districtId: resultingArray[0] }, allowMultiple);
      }
      this.closeExpanderIfNotInMobile();
    });
    this.$bus.$on('autocompleteStreetSelected', (street) => {
      const resultingArray = this.getFilterValue('streetId').concat([street.streetId]);
      if (resultingArray.length > 0) {
        const allowMultiple = !!this.$route.query?.streetId;
        searchUtils.addFilterToUrl(this.$router, this.$route, { streetId: resultingArray[0] }, allowMultiple);
      }
      this.closeExpanderIfNotInMobile();
    });
    this.$bus.$on('autocompleteRegionSelected', (region) => {
      const resultingArray = this.getFilterValue('regionId').concat([region.regionId]);
      if (resultingArray.length > 0) {
        const allowMultiple = !!this.$route.query?.regionId;
        searchUtils.addFilterToUrl(this.$router, this.$route, { regionId: resultingArray[0] }, allowMultiple);
      }
      this.closeExpanderIfNotInMobile();
    });
    this.$bus.$on('autocompleteCitySelected', (city) => {
      const resultingArray = this.getFilterValue('cityId').concat([city.cityId]);
      if (resultingArray.length > 0) {
        const allowMultiple = !!this.$route.query?.cityId;
        searchUtils.addFilterToUrl(this.$router, this.$route, { cityId: resultingArray[0] }, allowMultiple);
      }
      this.closeExpanderIfNotInMobile();
    });
    this.$bus.$on('autocompleteCountySelected', (county) => {
      const resultingArray = this.getFilterValue('countyId').concat([county.countyId]);
      if (resultingArray.length > 0) {
        const allowMultiple = !!this.$route.query?.countyId;
        searchUtils.addFilterToUrl(this.$router, this.$route, { countyId: resultingArray[0] }, allowMultiple);
      }
      this.closeExpanderIfNotInMobile();
    });
    this.$bus.$on('autocompletePostalCodeSelected', (postalCode) => {
      const resultingArray = this.getFilterValue('postalCode').concat([postalCode.toString()]);
      if (resultingArray.length > 0) {
        const allowMultiple = !!this.$route.query?.postalCode;
        searchUtils.addFilterToUrl(this.$router, this.$route, { postalCode: resultingArray[0] }, allowMultiple);
      }
      this.closeExpanderIfNotInMobile();
    });
  },
  beforeUnmount() {
    this.$bus.$off('autocompleteDistrictSelected');
    this.$bus.$off('autocompleteStreetSelected');
    this.$bus.$off('autocompleteRegionSelected');
    this.$bus.$off('autocompleteCitySelected');
    this.$bus.$off('autocompleteCountySelected');
    this.$bus.$off('autocompletePostalCodeSelected');
  },
  components: {
    ActiveFilters,
    Expander,
    FormInput,
    Autocomplete,
  },
};
</script>
